import TabletMobileFilterRedesign, {
  TabletMobileFilterProps
} from './tabletMobileFilterRedesign'

export type { TabletMobileFilterProps }
export default TabletMobileFilterRedesign
